(function () {
  function initVideoPlay(root) {
    root.querySelectorAll('.js-lp-review-video').forEach(function (frame) {
      var btn = frame.querySelector('.js-lp-review-play');
      var video = frame.querySelector('video.lp-Reviews_VideoEl');
      var iframe = frame.querySelector('iframe.lp-Reviews_YtFrame');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (video) {
          video.controls = true;
          video.muted = false;
          var p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {});
          }
        }
        if (iframe && iframe.dataset.src) {
          var u = iframe.dataset.src;
          if (u.indexOf('?') >= 0) {
            iframe.src = u + '&autoplay=1';
          } else {
            iframe.src = u + '?autoplay=1';
          }
        }
        btn.classList.add('is-hidden');
      });
    });
  }

  function destroySwiper(el) {
    if (el && el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  function initSwiper(root) {
    var swEl = root.querySelector('.js-lp-reviews-swiper');
    var pagEl = root.querySelector('.js-lp-reviews-pagination');
    if (!swEl || typeof Swiper === 'undefined') return;

    destroySwiper(swEl);

    var opts = {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      speed: 400,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };
    if (pagEl) {
      opts.pagination = { el: pagEl, clickable: true };
    }
    new Swiper(swEl, opts);
  }

  function initRoot(root) {
    if (!root) return;
    initVideoPlay(root);
    initSwiper(root);
  }

  function initAll() {
    document.querySelectorAll('[data-lp-reviews-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector && event.target.querySelector('[data-lp-reviews-root]');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sw = event.target && event.target.querySelector && event.target.querySelector('.js-lp-reviews-swiper');
    destroySwiper(sw);
  });
})();
